/* unplugin-vue-components disabled */import { render } from "./job.vue?vue&type=template&id=a11eb97a&scoped=true"
import script from "./job.vue?vue&type=script&lang=js"
export * from "./job.vue?vue&type=script&lang=js"

import "./job.vue?vue&type=style&index=0&id=a11eb97a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a11eb97a"],['__file',"src/components/cards/persona/jobs/job.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a11eb97a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a11eb97a', __exports__)) {
    api.reload('a11eb97a', __exports__)
  }
  
  module.hot.accept("./job.vue?vue&type=template&id=a11eb97a&scoped=true", () => {
    api.rerender('a11eb97a', render)
  })

}


export default __exports__